import React, { useState, useEffect } from "react";
import "./Calendar.css";
import TaskModal from "./TaskModelComponent";
import TaskList from "./TaskList";
import Button from '@mui/material/Button';
import DeleteAndEditEvent from "./DeleteandEditEvent";


const FullCalendar = (props) => {
  const{ tasks,setEvents,email} = props;
  const [currentDate, setCurrentDate] = useState(new Date()); // Current date


  const [selectedDate, setSelectedDate] = useState(null); // Selected day for task list
  const[addEvent,SetAddEvent] = useState(false);

  // Generate days for the current month
  const getDaysInMonth = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const days = [];

    // Add leading empty cells for the week
    for (let i = 0; i < firstDay.getDay(); i++) {
      days.push(null);
    }

    // Add days of the month
    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push(new Date(year, month, i));
    }

    return days;
  };

  // Format tasks for easy lookup by date
  const tasksByDate = tasks.reduce((acc, task) => {
    const taskDate = new Date(task.start.dateTime).toDateString();
    if (!acc[taskDate]) acc[taskDate] = [];
    acc[taskDate].push(task);
    return acc;
  }, {});

  return (
    <div className="calendar-container">
      
      <header>
      <TaskModal  email={email} setEvents={setEvents}  />
      
        <Button variant="outlined"  onClick={() => setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)))}>
          {"<"}
        </Button>
      
        <h2>
          {currentDate.toLocaleString("default", { month: "long" })} {currentDate.getFullYear()}
        </h2>
        <Button variant="outlined" onClick={() => setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)))}>
          {">"}
        </Button>
      </header>

      <div className="calendar-grid">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div className="day-header" key={day}>
            {day}
          </div>
        ))}
        {getDaysInMonth().map((day, index) => (
          <div
            key={index}
            className={`day-cell ${day && day.toDateString() === new Date().toDateString() ? "current-day" : ""}`}
            onClick={() => {
              if (day) setSelectedDate(day.toDateString());
            }}
          >
            {day ? day.getDate() : ""}
            {tasksByDate[day?.toDateString()] && (
              <div className="task-indicator">
                {"    "}
              </div>
            )}
          </div>
        ))}
      </div>

      {selectedDate &&<DeleteAndEditEvent email={email} selectedDate={selectedDate} events={tasksByDate[selectedDate]||[]}  onEdit={(id)=>{console.log(id)}} setSelectedDate={setSelectedDate} tasks={tasks} setEvents={setEvents}/>}
      
    </div>
  );
};

export default FullCalendar;
